import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyAH_fU1sWNtDoU92QyjBWkiGX5Wjre4cIM",
  authDomain: "hakathon-9733a.firebaseapp.com",
  projectId: "hakathon-9733a",
  storageBucket: "hakathon-9733a.firebasestorage.app",
  messagingSenderId: "879536909731",
  appId: "1:879536909731:web:17d3f71b4862063e157e16",
  measurementId: "G-VE5V4G54VD"
};
// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const ADMIN_EMAIL = "shizasultan117@gamil.com"; 
